import { AnyAction } from "redux";
import { cloneDeep } from "lodash";
import { FETCH_TYPES } from "../actions/allergies";

interface IAllergies {
  types: string[];
}

const initialState: IAllergies = {
  types: [],
};

export const AllergiesReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case FETCH_TYPES: {
      return {
        ...cloneDeep(state),
        types: action.types,
      };
    }
    default: {
      return state;
    }
  }
};
